function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fetchPolizaPayment, updatePolizaPayment } from "../bitacora/actions/PolizaPaymentActions";
import * as moment from "moment";

var PolizaPaymentHistoryTable = function PolizaPaymentHistoryTable(props) {
  var poliza_payments = props.poliza_payments,
      token = props.token,
      admin = props.admin;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      editingRow = _React$useState2[0],
      setEditingRow = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      editData = _React$useState4[0],
      setEditData = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      loadingEdit = _React$useState6[0],
      setLoadingEdit = _React$useState6[1];

  var formatDate = function formatDate(dateString) {
    if (!dateString) return "";
    return moment(dateString).format("DD/MM/YYYY");
  };

  var formatDateForAPI = function formatDateForAPI(date) {
    if (!date) return null;
    return moment(date).format("YYYY-MM-DD");
  };

  var parseDateString = function parseDateString(dateString) {
    if (!dateString) return null;
    return moment(dateString).toDate();
  };

  var handleStartEdit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payment, index) {
      var paymentData, amountValue, currentData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoadingEdit(true);
              _context.prev = 1;
              _context.next = 4;
              return fetchPolizaPayment(payment.id);

            case 4:
              paymentData = _context.sent;
              amountValue = paymentData.amount ? parseFloat(paymentData.amount.toString()) : null;
              currentData = {
                due_date: paymentData.due_date ? parseDateString(paymentData.due_date) : null,
                amount: amountValue,
                paid_amount: paymentData.payment_received_at ? amountValue : null,
                payment_received_at: paymentData.payment_received_at ? parseDateString(paymentData.payment_received_at) : null,
                is_paid: !!paymentData.payment_received_at
              };
              setEditData(currentData);
              setEditingRow(index);
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              alert("Error al cargar los datos para editar. Por favor, intenta de nuevo.");

            case 14:
              _context.prev = 14;
              setLoadingEdit(false);
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11, 14, 17]]);
    }));

    return function handleStartEdit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleCancelEdit = function handleCancelEdit() {
    setEditingRow(null);
    setEditData(null);
  };

  var handleSaveEdit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payment) {
      var updateData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (editData) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              setLoadingEdit(true);
              _context2.prev = 3;
              updateData = {
                id: payment.id
              };

              if (editData.due_date !== undefined) {
                updateData.due_date = formatDateForAPI(editData.due_date);
              } // Handle payment status (is_paid checkbox) first


              if (editData.is_paid !== undefined) {
                if (editData.is_paid) {
                  // If marking as paid, set payment_received_at if not already set
                  if (!editData.payment_received_at) {
                    updateData.payment_received_at = formatDateForAPI(new Date());
                  } else {
                    updateData.payment_received_at = formatDateForAPI(editData.payment_received_at);
                  }
                } else {
                  // If unmarking as paid, clear payment_received_at
                  updateData.payment_received_at = null;
                }
              } else if (editData.payment_received_at !== undefined) {
                // If payment_received_at is explicitly set (via date picker)
                updateData.payment_received_at = formatDateForAPI(editData.payment_received_at);
              } // Handle amount: prioritize paid_amount if payment is marked as paid, otherwise use amount (valor cuota)


              if (editData.is_paid && editData.paid_amount !== undefined && editData.paid_amount !== null) {// If marked as paid and paid_amount is set, use paid_amount. paid amount does not exist yet in the model, so we don't update it.
                //updateData.paid_amount = editData.paid_amount;
              } else if (editData.amount !== undefined && editData.amount !== null) {
                // Otherwise, use the valor cuota (amount)
                updateData.amount = editData.amount;
              }

              _context2.next = 10;
              return updatePolizaPayment(updateData, token);

            case 10:
              // Recargar la página para mostrar los cambios actualizados
              window.location.reload();
              _context2.next = 16;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](3);
              alert("Error al guardar los cambios. Por favor, intenta de nuevo.");

            case 16:
              _context2.prev = 16;
              setLoadingEdit(false);
              return _context2.finish(16);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 13, 16, 19]]);
    }));

    return function handleSaveEdit(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getOverdueStatusBadge = function getOverdueStatusBadge(payment) {
    switch (payment.overdue_status) {
      case 'overdue':
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-danger",
          style: {
            padding: "4px 8px",
            fontSize: "11px",
            borderRadius: "3px"
          }
        }, payment.overdue_days, " d\xEDas");

      case 'current':
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-success",
          style: {
            padding: "4px 8px",
            fontSize: "11px",
            borderRadius: "3px"
          }
        }, "Al d\xEDa");

      case 'paid':
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-info",
          style: {
            padding: "4px 8px",
            fontSize: "11px",
            borderRadius: "3px"
          }
        }, "Pagado");

      default:
        return /*#__PURE__*/React.createElement("span", {
          className: "text-muted"
        }, "Sin informaci\xF3n");
    }
  };

  var getPaymentStatusBadge = function getPaymentStatusBadge(payment) {
    if (payment.payment_received_at) {
      return /*#__PURE__*/React.createElement("span", {
        className: "label label-success",
        style: {
          padding: "6px 12px",
          fontSize: "12px",
          borderRadius: "4px"
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-check",
        style: {
          marginRight: "4px"
        }
      }), "Pagado");
    } else {
      return /*#__PURE__*/React.createElement("span", {
        className: "label label-warning",
        style: {
          padding: "6px 12px",
          fontSize: "12px",
          borderRadius: "4px",
          backgroundColor: "#f39c12"
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-clock-o",
        style: {
          marginRight: "4px"
        }
      }), "Por pagar");
    }
  };

  var canEdit = admin.is_super_admin || admin.permissions_code.includes("poliza_payment_edit");
  return /*#__PURE__*/React.createElement("div", {
    className: "poliza-payment-history"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement("b", null, "Historial de cobranza"))), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-responsive"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table table-striped poliza-payment-history",
    "data-toggle": "table",
    style: {
      tableLayout: "fixed",
      width: "100%",
      minWidth: "1200px"
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    style: {
      width: "5%",
      textAlign: "center",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "1.2",
      padding: "8px 4px"
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "select-all-cuotas",
    title: "COBRAR"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", {
    className: "text-muted"
  }, "COBRAR")), /*#__PURE__*/React.createElement("th", {
    style: {
      width: "4%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "1.2",
      padding: "8px 4px"
    },
    "data-sortable": "true"
  }, "Cuota"), /*#__PURE__*/React.createElement("th", {
    style: {
      width: "10%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "1.2",
      padding: "8px 4px"
    },
    "data-sortable": "true"
  }, "Vencimiento"), /*#__PURE__*/React.createElement("th", {
    style: {
      width: "8%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "1.2",
      padding: "8px 4px"
    },
    "data-sortable": "true"
  }, "D\xEDas de", /*#__PURE__*/React.createElement("br", null), "Atraso"), /*#__PURE__*/React.createElement("th", {
    style: {
      width: "7%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "1.2",
      padding: "8px 4px"
    },
    "data-sortable": "true"
  }, "Valor Cuota"), /*#__PURE__*/React.createElement("th", {
    style: {
      width: "7%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "1.2",
      padding: "8px 4px"
    },
    "data-sortable": "true"
  }, "Monto", /*#__PURE__*/React.createElement("br", null), "Pagado"), /*#__PURE__*/React.createElement("th", {
    style: {
      width: "11%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "1.2",
      padding: "8px 4px"
    },
    "data-sortable": "true"
  }, "Fecha de", /*#__PURE__*/React.createElement("br", null), "Pago"), /*#__PURE__*/React.createElement("th", {
    style: {
      width: "11%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "1.2",
      padding: "8px 4px"
    },
    "data-sortable": "true"
  }, "Estado de", /*#__PURE__*/React.createElement("br", null), "Pago"), /*#__PURE__*/React.createElement("th", {
    style: {
      width: "12%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "1.2",
      padding: "8px 4px"
    },
    "data-sortable": "true"
  }, "\xDAltimo", /*#__PURE__*/React.createElement("br", null), "Recordatorio"), /*#__PURE__*/React.createElement("th", {
    style: {
      width: "12%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "1.2",
      padding: "8px 4px"
    },
    "data-sortable": "true"
  }, "Realizado", /*#__PURE__*/React.createElement("br", null), "por"), /*#__PURE__*/React.createElement("th", {
    style: {
      width: "12%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "1.2",
      padding: "8px 4px"
    }
  }, "Acciones"))), /*#__PURE__*/React.createElement("tbody", null, poliza_payments.map(function (payment, index) {
    var isEditing = editingRow === index;
    return /*#__PURE__*/React.createElement("tr", {
      key: payment.id
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      name: "cuota_ids[]",
      value: payment.id,
      className: "cuota-checkbox",
      title: "COBRAR ".concat(payment.installment_number)
    })), /*#__PURE__*/React.createElement("td", null, payment.installment_number), /*#__PURE__*/React.createElement("td", null, isEditing && editData ? /*#__PURE__*/React.createElement(DatePicker, {
      className: "form-control",
      dateFormat: "dd-MM-yyyy",
      selected: editData.due_date,
      onChange: function onChange(date) {
        setEditData(_objectSpread(_objectSpread({}, editData), {}, {
          due_date: date
        }));
      },
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "12px"
      }
    }) : formatDate(payment.due_date)), /*#__PURE__*/React.createElement("td", null, getOverdueStatusBadge(payment)), /*#__PURE__*/React.createElement("td", null, isEditing && editData ? /*#__PURE__*/React.createElement("input", {
      type: "number",
      step: "0.001",
      className: "form-control",
      value: editData.amount !== undefined && editData.amount !== null ? editData.amount : "",
      onChange: function onChange(e) {
        var value = e.target.value === "" ? null : parseFloat(e.target.value);
        setEditData(_objectSpread(_objectSpread({}, editData), {}, {
          amount: value
        }));
      },
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "12px",
        MozAppearance: "textfield"
      },
      placeholder: "Valor cuota",
      onWheel: function onWheel(e) {
        return e.currentTarget.blur();
      }
    }) : payment.amount_text), /*#__PURE__*/React.createElement("td", null, isEditing && false && editData ?
    /*#__PURE__*/
    //  paidAmount does not exist yet in the model
    React.createElement("input", {
      type: "number",
      step: "0.001",
      className: "form-control",
      value: editData.paid_amount !== undefined && editData.paid_amount !== null ? editData.paid_amount : editData.is_paid ? editData.amount || "" : "",
      onChange: function onChange(e) {
        var value = e.target.value === "" ? null : parseFloat(e.target.value);
        setEditData(_objectSpread(_objectSpread({}, editData), {}, {
          paid_amount: value
        }));
      },
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "12px",
        MozAppearance: "textfield"
      },
      placeholder: "Monto pagado",
      disabled: !editData.is_paid,
      onWheel: function onWheel(e) {
        return e.currentTarget.blur();
      }
    }) : payment.payment_received_at ? payment.amount_text : "CLF 0"), /*#__PURE__*/React.createElement("td", null, isEditing && editData && editData.is_paid ? /*#__PURE__*/React.createElement(DatePicker, {
      className: "form-control",
      dateFormat: "dd-MM-yyyy",
      selected: editData.payment_received_at,
      onChange: function onChange(date) {
        setEditData(_objectSpread(_objectSpread({}, editData), {}, {
          payment_received_at: date
        }));
      },
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "12px"
      }
    }) : formatDate(payment.payment_received_at)), /*#__PURE__*/React.createElement("td", null, isEditing && editData ? /*#__PURE__*/React.createElement("label", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: editData.is_paid || false,
      onChange: function onChange(e) {
        var isPaid = e.target.checked;
        setEditData(_objectSpread(_objectSpread({}, editData), {}, {
          is_paid: isPaid,
          payment_received_at: isPaid && !editData.payment_received_at ? new Date() : isPaid ? editData.payment_received_at : null,
          paid_amount: isPaid && editData.paid_amount === null ? editData.amount : editData.paid_amount
        }));
      },
      style: {
        margin: 0
      }
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: "12px"
      }
    }, editData.is_paid ? "Pagado" : "Por pagar")) : getPaymentStatusBadge(payment)), /*#__PURE__*/React.createElement("td", null, payment.reminder_sent_at ? formatDate(payment.reminder_sent_at) : /*#__PURE__*/React.createElement("span", {
      className: "text-muted"
    }, "Sin recordatorio")), /*#__PURE__*/React.createElement("td", null, payment.last_action_performed_by ? payment.last_action_performed_by : /*#__PURE__*/React.createElement("span", {
      className: "text-muted"
    }, "Sin acciones registradas")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "btn-group",
      role: "group"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/admin/poliza_payments/".concat(payment.id),
      className: "btn btn-mini btn-success",
      title: "Ver detalles",
      "data-toggle": "tooltip",
      "data-placement": "top"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-eye"
    })), canEdit && /*#__PURE__*/React.createElement(React.Fragment, null, isEditing ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: "btn btn-mini btn-success",
      title: "Guardar",
      "data-toggle": "tooltip",
      "data-placement": "top",
      onClick: function onClick() {
        return handleSaveEdit(payment);
      },
      disabled: loadingEdit
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-check"
    })), /*#__PURE__*/React.createElement("button", {
      className: "btn btn-mini btn-danger",
      title: "Cancelar",
      "data-toggle": "tooltip",
      "data-placement": "top",
      onClick: handleCancelEdit,
      disabled: loadingEdit
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-times"
    }))) : /*#__PURE__*/React.createElement("button", {
      className: "btn btn-mini btn-info",
      title: "Editar pago",
      "data-toggle": "tooltip",
      "data-placement": "top",
      onClick: function onClick() {
        return handleStartEdit(payment, index);
      },
      disabled: loadingEdit
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-edit"
    }))), /*#__PURE__*/React.createElement("a", {
      href: "/admin/poliza_payments/".concat(payment.id),
      className: "btn btn-mini btn-danger",
      title: "Eliminar pago",
      "data-toggle": "tooltip",
      "data-placement": "top",
      "data-method": "delete",
      "data-confirm": "\xBFEst\xE1 seguro?"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-trash"
    })))));
  })))))));
};

export default PolizaPaymentHistoryTable;